import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMedia } from 'react-use'

import { hasSelectedTickets } from '../../selectors/selectors'
import SerialTicketsBooking from '../SerialTicketsBooking/SerialTicketsBooking'
import LinkAddVoucher from '../voucher/LinkAddVoucher/LinkAddVoucher'
import BuyButton from './BuyButton/BuyButton'

export default function Booking() {
  const smUp = useMedia(mediaQueries.smUp, true)
  const hasTicketsInCart = useSelector(hasSelectedTickets)

  return (
    <>
      <SerialTicketsBooking />
      {!smUp && <LinkAddVoucher />}
      {!smUp && hasTicketsInCart && <BuyButton />}
    </>
  )
}
